import { ChatMessage, MessageType, getRegistration, messageHasWidgetType, useConversation } from '@chewy/chat-library-common';
import { useMemo } from 'react';
import React from 'react';
import cn from 'classnames';
import styles from './StructuredMessage.module.scss';

interface StructuredMessageProps {
  message?: ChatMessage;
}

export default function StructuredMessage({ message }: StructuredMessageProps) {
  const { requestScroll } = useConversation();

  const children = useMemo(() => {

    if (typeof message?.content === 'string' || !message?.content) {
      console.warn('StructuredMessage: Message does not contain WidgetContent: ', message?.content);
      return null;
    }

    return message.content.map((item, index) => {
      if (!item.widgetType) {
        console.warn('StructuredMessage: item missing widgetType', item);
        return null;
      }

      const registration = getRegistration(item.widgetType);

      if (!registration?.component) {
        console.warn(`StructuredMessage: Bad registration: The results were: ${registration}`);
        console.warn(`StructuredMessage: No component registered for widget type: ${item.widgetType}`);
        return null;
      }

      // Create a ChatMessage wrapper for the widget data
      const widgetMessage: ChatMessage = {
        ...message,
        type: item.widgetType as MessageType,
        content: [item]
      };

      // Skip animations for transcript messages
      const isFromTranscript = message.source === 'TRANSCRIPT';
      const skipHeartAnimation = item.widgetType.toLowerCase() === 'textheartanimation' && isFromTranscript;

      return React.createElement(registration.component as any, {
        key: `widget-${index}`,
        message: widgetMessage,
        data: item.widgets,
        payload: item.widgets,
        trigger: skipHeartAnimation ? false : undefined,
        requestScroll,
      });
    }).filter(Boolean);
  }, [message, requestScroll]);

  return (
    <div
      className={cn(styles.structuredMessage, {
        [styles.structuredMessage_petProfile]: message && messageHasWidgetType(message, 'PetProfileCard'),
      })}
    >
      {children}
    </div>
  );
}
